import styled from 'styled-components';

export const FillingFastSection = styled.div`
    font-size: 1.2rem;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    img{
        width: 1.5rem;
        height: 1.2rem;
        margin-right: 0.2rem;
    }
`;

export const TextSection = styled.span(
    props => `
        color: ${props.colorCode};
    `)
;
